import React from 'react'

const NoVideosFoundSection = () => {
  return (
    <div className='no-videos-section' style={{display:'flex', justifyContent:'center', alignItems:'center', padding:'60px 20px'}}>
        <h3 className='no-videos-text' style={{font:'bold', color:'white',fontFamily:'Good Times'}}>No Videos To Show</h3>
    </div>
  )
}

export default NoVideosFoundSection